var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 31L46.5 30.7C46.5 13.5 52.1667 14.8333 55 15V1C33 1 30.9996 21.5 31 31V57H55V31Z",
    stroke: "#969A9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31L16.5 30.7C16.5 13.5 22.1667 14.8333 25 15V1C3 1 0.999597 21.5 1 31V57H25V31Z",
    stroke: "#969A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesWhite);
export default __webpack_public_path__ + "static/media/quotesWhite.1929f8e1efb8018afa4fcc9d89f95e6b.svg";
export { ForwardRef as ReactComponent };